/**
 * Index - Data Configuration
 * 
 * Arquivo de exportação centralizada para facilitar imports
 * Agora com suporte a branding white-label
 */

// Carrega branding ativo
import { activeConfig } from './parceiros/brandingManager';

// Usa configuração do parceiro ativo ao invés da config padrão
const config = activeConfig;

export { config };
export { default as colors, getColor, getCSSVariables } from './colors';
export { default as texts, getText, interpolate } from './texts';
export { default as images, getImage, getImageUrl } from './images';
export { default as links, getLink, formatPhone } from './links';
export { default as content, getOfertas, getFAQByCategory, searchFAQ } from './content';

export {
  getConfig,
  isFeatureEnabled,
  formatCurrency,
  formatDate,
  loadClientConfig,
  applyTheme,
  shouldShowComponent,
  shouldShowElement,
  getVisibleComponents,
  getPageConfig,
  getEnabledPages,
  getMenuPages,
  getRoutes,
  isPageEnabled,
} from './config';

// Export default
export default config;
